export const loaded = (state) => {
  return state.loaded
}
